import { HolidayDescription } from './HolidayDescription';
import { DateTime } from 'luxon';
export class Session {
    constructor(id, name) {
        this.CurrentSessionPeriod = null;
        this.TimeOffset = 0;
        this.FirstDayOfWeek = 1; // Monday by default (0 - Sunday, 1 - Monday, 2 - Tuesday, 3 - Wednesday, 4 - Thursday, 5 - Friday, 6 - Saturday)
        this._holidays = new Map();
        this._sessionPeriods = [];
        this.Id = id;
        this.Name = name;
    }
    newMessage(msg) {
        this.BlockTrading = msg.blockTrading;
        if (!isNullOrUndefined(msg.timeZoneID)) {
            this.TimeZoneID = msg.timeZoneID;
        }
        if (!isNullOrUndefined(msg.timeOffset)) {
            this.TimeOffset = msg.timeOffset;
        }
        if (!isNullOrUndefined(msg.periods)) {
            this._sessionPeriods = msg.periods;
        }
        if (!isNullOrUndefined(msg.holidays)) {
            this._holidays = msg.holidays;
        }
        this.CurrentSessionPeriod = this.GetSessionPeriodByID(msg.currentPeriodId);
        if (!isNullOrUndefined(msg.serverBeginDayDate)) {
            this.ServerBeginDayDate = msg.serverBeginDayDate;
            this.ServerTodayDate = this.ConvertDateToSessionDateTime(this.ServerBeginDayDate).startOf('day');
            this.ServerBeginDayDateTime = DateTime.fromJSDate(this.ServerBeginDayDate, { zone: this.TimeZoneID });
        }
        if (!isNullOrUndefined(msg.firstDayOfWeek)) {
            this.FirstDayOfWeek = msg.firstDayOfWeek;
        }
    }
    getSessionPeriods() {
        return this._sessionPeriods;
    }
    getHolidays() {
        return this._holidays;
    }
    ConvertDateToSessionDateTime(date) {
        const datetimeInSessionTimeZone = DateTime.fromMillis(date.getTime(), { zone: this.TimeZoneID });
        const datetimeInSessionTimeZoneWithOffset = datetimeInSessionTimeZone.plus({
            minutes: -this.TimeOffset
        });
        return datetimeInSessionTimeZoneWithOffset;
    }
    ConvertSessionDateTimeToDate(sessDate) {
        const datetimeInSessionTimeZoneWithOffset = sessDate.plus({ minutes: this.TimeOffset });
        return datetimeInSessionTimeZoneWithOffset.toJSDate();
    }
    AddTimeToSessionDate(sessDate, sessTime) {
        const sessionDay = sessDate.startOf('day');
        const sessionTime = sessionDay.plus({ milliseconds: sessTime.getTime() });
        return sessionTime;
    }
    FindSessionPeriodsForDate(sessDate) {
        let sessionPeriods = this._sessionPeriods;
        const holidayKey = HolidayDescription.createHolidayKey(sessDate.year, sessDate.month, sessDate.day);
        if (this._holidays.has(holidayKey)) {
            const holidayDesciption = this._holidays.get(holidayKey);
            if (holidayDesciption.IsShorted() && holidayDesciption.HasPeriods()) {
                sessionPeriods = holidayDesciption.GetHolidayPeriods();
            }
        }
        const dayOfWeek = sessDate.weekday % 7; // Sunday (7) -> 0
        return [sessionPeriods, dayOfWeek];
    }
    GetSessionPeriodRange(date, isFilterNotAllowedPeriods, showExtendedSession) {
        const dateTimeInSessionTimeZoneWithOffset = this.ConvertDateToSessionDateTime(date);
        const [sessionPeriods, dayOfWeek] = this.FindSessionPeriodsForDate(dateTimeInSessionTimeZoneWithOffset);
        let allowedPeriods = sessionPeriods;
        if (isFilterNotAllowedPeriods) {
            allowedPeriods = allowedPeriods.filter((period) => !period.isBeforeOrAfterMarket());
        }
        if (!showExtendedSession) {
            allowedPeriods = allowedPeriods.filter((period) => period.IsMain());
        }
        if (allowedPeriods.length === 0) {
            return [new Date(0), new Date(0)];
        }
        const firstSessionPeriod = allowedPeriods[0];
        const lastSessionPeriod = allowedPeriods[allowedPeriods.length - 1];
        const startFirstSession = firstSessionPeriod.GetBegin(dayOfWeek);
        const endLastSession = lastSessionPeriod.GetEnd(dayOfWeek);
        const start = this.AddTimeToSessionDate(dateTimeInSessionTimeZoneWithOffset, startFirstSession);
        const end = this.AddTimeToSessionDate(dateTimeInSessionTimeZoneWithOffset, endLastSession);
        return [this.ConvertSessionDateTimeToDate(start), this.ConvertSessionDateTimeToDate(end)];
    }
    FindSessionPeriod(datetimeUtc) {
        // сначала проверяем текущую сессию (over99% котировок принадлежат ей - для производительности)
        const currentPeriod = this.CurrentSessionPeriod;
        if (!datetimeUtc || datetimeUtc.getUTCFullYear() <= 1970) {
            // idbm for example
            return currentPeriod;
        }
        const dateTimeInSessionTimeZoneWithOffset = this.ConvertDateToSessionDateTime(datetimeUtc);
        const [sessionPeriods, dayOfWeek] = this.FindSessionPeriodsForDate(dateTimeInSessionTimeZoneWithOffset);
        if (this.ServerTodayDate.equals(dateTimeInSessionTimeZoneWithOffset.startOf('day')) &&
            currentPeriod != null &&
            this.CheckSession(currentPeriod, dayOfWeek, dateTimeInSessionTimeZoneWithOffset)) {
            return currentPeriod;
        }
        return sessionPeriods.find((x) => this.CheckSession(x, dayOfWeek, dateTimeInSessionTimeZoneWithOffset));
    }
    CheckSession(sessionPeriod, dayOfWeek, datetimeInSessionTimeZoneWithOffset) {
        const begin = sessionPeriod.GetBegin(dayOfWeek);
        const end = sessionPeriod.GetEnd(dayOfWeek);
        // hsa: skip periods that have the same start and end
        // this is possible to set the same start and in session settings
        // it is valid for the case when they want to mark only some period
        if (begin.getTime() === end.getTime()) {
            return false;
        }
        const startTime = this.AddTimeToSessionDate(datetimeInSessionTimeZoneWithOffset, begin);
        const endTime = this.AddTimeToSessionDate(datetimeInSessionTimeZoneWithOffset, end);
        return (startTime < endTime &&
            startTime <= datetimeInSessionTimeZoneWithOffset &&
            datetimeInSessionTimeZoneWithOffset < endTime);
    }
    // ?
    isServerTodayDate(date) {
        return this.ServerTodayDate.toJSDate().isSameDay(date);
    }
    GetTodayHoliday() {
        const todayServerDate = this.ServerTodayDate;
        if (isNullOrUndefined(todayServerDate)) {
            return null;
        }
        const key = HolidayDescription.createHolidayKey(todayServerDate.year, todayServerDate.month, todayServerDate.day);
        return this._holidays.has(key) ? this._holidays.get(key) : null;
    }
    GetStartSessionDayOfWeek() {
        var _a;
        return (_a = this.ServerBeginDayDateTime) === null || _a === void 0 ? void 0 : _a.weekday;
    }
    GetStartSessionTodayDay() {
        var _a;
        return (_a = this.ServerBeginDayDateTime) === null || _a === void 0 ? void 0 : _a.day;
    }
    getSortedHolidays() {
        const sortedHolidays = Array.from(this._holidays.values()).sort((a, b) => a.key.localeCompare(b.key));
        return sortedHolidays;
    }
    isFutureHoliday(holiday) {
        const today = this.ServerTodayDate;
        const holidayDate = DateTime.fromObject({
            year: holiday.year,
            month: holiday.month,
            day: holiday.day
        }, { zone: this.TimeZoneID });
        return holidayDate >= today;
    }
    GetNextHoliday() {
        const holidays = this.getSortedHolidays();
        for (const holiday of holidays) {
            if (this.isFutureHoliday(holiday)) {
                return holiday;
            }
        }
        return null;
    }
    GetTodayDayPeriods() {
        const [sessionPeriods] = this.FindSessionPeriodsForDate(this.ServerTodayDate.toJSDate());
        return sessionPeriods === null || sessionPeriods === void 0 ? void 0 : sessionPeriods.map((x) => x.dayPeriod);
    }
    GetSessionPeriodByID(periodId) {
        let sessionPeriod = this._sessionPeriods.find((m) => m.id === periodId);
        if (!isNullOrUndefined(sessionPeriod)) {
            return sessionPeriod;
        }
        const holiday = this.GetTodayHoliday();
        if (!isNullOrUndefined(holiday) && !isNullOrUndefined(holiday.sessionPeriods)) {
            sessionPeriod = holiday.sessionPeriods.find((m) => m.id === periodId);
        }
        if (!isNullOrUndefined(sessionPeriod)) {
            return sessionPeriod;
        }
        // hsa: I'm not sure that we need to search in all holidays
        const nonEmptyHolidays = Array.from(this._holidays.values()).filter((x) => x.sessionPeriods != null);
        for (const hDay of nonEmptyHolidays) {
            sessionPeriod = hDay.sessionPeriods.find((m) => m.id === periodId);
            if (!isNullOrUndefined(sessionPeriod)) {
                return sessionPeriod;
            }
        }
        return null;
    }
}
